import styled from 'styled-components';
import { COLORS } from '@/theme';

export const StyledStats = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

export const StyledErrorsList = styled.ul`
  max-height: 12rem;
  overflow-y: auto;
  margin: 0 0 1rem;
  padding-left: 1.25rem;
`;

export const StyledErrorRow = styled.li`
  color: ${COLORS.STATUS_ERROR};
`;

export const StyledButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
`;
